import { TranslateService } from '@ngx-translate/core';
import { ProductService } from './product.service';
import { Injectable } from '@angular/core';
import { LanguageDto } from 'gast-common-ng/lib/shared/dto/language-dto';
import { HeaderModel } from 'gast-portal-ng/lib/header/model/header-model';
import { LanguageModel } from 'gast-portal-ng/lib/header-deprecated/model/language-model';
import { NavTabUrlModel } from 'gast-portal-ng/lib/header/model/nav-tab-url-model';
import { LinkModel } from 'gast-portal-ng/lib/shared/dto/link-model';
import { FooterModel } from 'gast-portal-ng/lib/footer/model/footer-model';
import { TextModel } from 'gast-portal-ng/lib/shared/dto/text-model';
import { HeaderStyleModel } from 'gast-portal-ng/lib/header/model/header-style-model';
import { TranslationService } from 'gast-common-ng';
import { ProductEnum } from "../enum/product.enum";

@Injectable({
  providedIn: 'root'
})
export class StylingService {

  constructor(
    private translationService: TranslationService,
    private translateService: TranslateService,
    private productService: ProductService
  ) {
  }

  private readonly TESTDAF_LOGO = 'portal-assets/img/testdaf-logo.svg';
  private readonly TESTDAF_STYLES = 'portal-assets/css/product/testdaf.css';
  private readonly TESTDAF_FAVICON = 'assets/img/testdaf-logo.png';

  private readonly TESTAS_LOGO_EN = 'portal-assets/img/testas-logo-en.svg';
  private readonly TESTAS_LOGO_DE = 'portal-assets/img/testas-logo-de.svg';
  private readonly TESTAS_STYLES = 'portal-assets/css/product/testas.css';
  private readonly TESTAS_FAVICON = 'assets/img/testas-logo.png';
  private readonly TESTAS_FOOTER_TEXT_DE = 'TestAS ist ein Angebot von';
  private readonly TESTAS_FOOTER_TEXT_EN = 'TestAS is provided by';

  private readonly DMAT_LOGO_EN = 'portal-assets/img/dMAT_Logo.svg';
  private readonly DMAT_LOGO_DE = 'portal-assets/img/dMAT_Logo.svg';
  private readonly DMAT_STYLES = 'portal-assets/css/product/dmat.css';
  private readonly DMAT_FAVICON = 'portal-assets/img/dmat-favicon.png';
  private readonly DMAT_FOOTER_TEXT_DE = 'DMAT ist ein Angebot von';
  private readonly DMAT_FOOTER_TEXT_EN = 'DMAT is provided by';

  private readonly GAST_LOGO = 'assets/img/gast_langversion.svg';
  private readonly DTZ_LOGO = 'assets/img/dtz-logo.jpg';
  private readonly DTZ_STYLES = 'assets/css/dtz.css';

  private readonly DE = { id: 1, code: 'DE', name: 'Deutsch' } as LanguageDto;
  private readonly EN = { id: 2, code: 'EN', name: 'English' } as LanguageDto;

  public generateProductHeaderModel(languages?: Array<LanguageDto>): HeaderModel {

    switch (this.productService.selectedProduct) {

      case ProductEnum.TESTDAF:
        return this.generateHeaderModel([], this.TESTDAF_LOGO, this.TESTDAF_LOGO);

      case ProductEnum.TESTAS: {
        if (this.isDELocale()) {
          return this.generateHeaderModel([this.DE, this.EN], this.TESTAS_LOGO_DE, this.TESTAS_LOGO_DE);
        }
        if (this.isENLocale()) {
          return this.generateHeaderModel([this.DE, this.EN], this.TESTAS_LOGO_EN, this.TESTAS_LOGO_EN);
        }
        break;
      }

      case ProductEnum.DMAT: {
        if (this.isDELocale()) {
          return this.generateHeaderModel([this.DE, this.EN], this.DMAT_LOGO_DE, this.DMAT_LOGO_DE);
        }
        if (this.isENLocale()) {
          return this.generateHeaderModel([this.DE, this.EN], this.DMAT_LOGO_EN, this.DMAT_LOGO_EN);
        }
        break;
      }

      case ProductEnum.DTZ: {

        if (this.isDELocale()) {
          return this.generateHeaderModel([], this.DTZ_LOGO, this.DTZ_LOGO, this.GAST_LOGO);
        }
        break;
      }

      default:
        return this.generateHeaderModel([], this.TESTDAF_LOGO, this.TESTDAF_LOGO)
    }
  }

  public generateProductFooter(): FooterModel {
    switch (this.productService.selectedProduct) {
      case ProductEnum.TESTDAF:
        return StylingService.generateTestDafFooter();
      case ProductEnum.TESTAS:
        if (this.isDELocale()) {
          return StylingService.generateFooter(this.TESTAS_FOOTER_TEXT_DE);
        }
        if (this.isENLocale()) {
          return StylingService.generateFooter(this.TESTAS_FOOTER_TEXT_EN);
        }
        break;
      case ProductEnum.DMAT:
        if (this.isDELocale()) {
          return StylingService.generateFooter(this.DMAT_FOOTER_TEXT_DE);
        }
        if (this.isENLocale()) {
          return StylingService.generateFooter(this.DMAT_FOOTER_TEXT_EN);
        }
        break;
      case ProductEnum.DTZ:
        return StylingService.generateDtzFooter();
      default:
        return StylingService.generateTestDafFooter();
    }
  }

  public getProductStyles(): string {
    switch (this.productService.selectedProduct) {
      case ProductEnum.TESTDAF: {
        return this.TESTDAF_STYLES;
      }
      case ProductEnum.TESTAS: {
        return this.TESTAS_STYLES;
      }
      case ProductEnum.DMAT: {
        return this.DMAT_STYLES;
      }
      case ProductEnum.DTZ: {
        return this.DTZ_STYLES;
      }
    }
  }

  public generateProductHeaderStyleModel(): HeaderStyleModel {
    switch (this.productService.selectedProduct) {
      case ProductEnum.TESTDAF: {
        return this.generateHeaderStyleModel(false);
      }
      case ProductEnum.TESTAS:
      case ProductEnum.DMAT: {
        return this.generateHeaderStyleModel(true);
      }
      case ProductEnum.DTZ: {
        return this.generateHeaderStyleModel(false, false);
      }
      default:
        return this.generateHeaderStyleModel(false);
    }
  }

  public getLogoPressedUrl() {
    switch (this.productService.selectedProduct) {
      case ProductEnum.TESTDAF: {
        return 'https://www.testdaf.de';
      }
      case ProductEnum.TESTAS: {
        return 'https://www.testas.de';
      }
      case ProductEnum.DMAT: {
        return 'https://www.d-mat.de';
      }
    }
  }

  public getFaviconLink() {
    if (this.productService.selectedProduct === ProductEnum.TESTDAF) {
      return this.TESTDAF_FAVICON;
    }

    if (this.productService.selectedProduct === ProductEnum.TESTAS) {
      return this.TESTAS_FAVICON;
    }

    if (this.productService.selectedProduct === ProductEnum.DMAT) {
      return this.DMAT_FAVICON;
    }

    if (this.productService.selectedProduct === ProductEnum.DTZ) {
      return this.TESTDAF_FAVICON;
    }
  }

  // ***************** COMPONENT CONFIGURATION *****************
  private generateHeaderModel(languages: Array<LanguageDto>, logoBigUrl: string, logoSmallUrl: string, logoGastBigUrl?: string): HeaderModel {
    return {
      languageModels: languages ? languages.map(l => {
        return { visibleText: l.name, code: l.code } as LanguageModel;
      }) : [],
      navigationTabUrls: [] as Array<NavTabUrlModel>,
      loginDropdownUrls: [] as Array<LinkModel>,
      loginDropdownProductUrls: [] as Array<LinkModel>,
      logoBigUrl: logoBigUrl,
      logoGastBigUrl: logoGastBigUrl,
      logoSmallUrl: logoSmallUrl,
    } as HeaderModel;
  }

  // tslint:disable:max-line-length
  private static generateTestDafFooter(): FooterModel {
    return {
      descriptionTitel: { text: 'Über TestDaF', useTranslation: false } as TextModel,
      descriptionText: {
        text: 'Sie möchten in Deutschland studieren und Ihre Sprachkenntnisse nachweisen? Dann ist der TestDaF die richtige Prüfung für Sie. Das TestDaF-Zertifikat wird von allen deutschen Hochschulen anerkannt. Überzeugen Sie Hochschulen, Forschungspartner und Arbeitgeber von Ihren Deutschkenntnissen. Kommen Sie in eines von über 500 Testzentren in 100 Ländern.',
        useTranslation: false
      } as TextModel,
      quickLinksTitle: { text: 'COMMON.FOOTER-COMPONENT.QUICK_LINKS.TITLE', useTranslation: true } as TextModel,
      quickLinks: [
        {
          text: 'Teilnehmende',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/teilnehmende/mein-testdaf/mit-dem-testdaf-an-eine-deutsche-hochschule/`
        } as LinkModel,
        {
          text: 'Hochschulen',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/hochschulen/der-testdaf-und-hochschulen/der-testdaf-an-ihrer-hochschule/`
        } as LinkModel,
        {
          text: 'Testzentren',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/testzentren/der-testdaf-an-ihrem-testzentrum/die-testzentren-von-gast/`
        } as LinkModel,
        { text: 'Lehrkräfte', useTranslation: false, linkUrl: `https://www.testdaf.de/de/lehrkraefte/` } as LinkModel,
        { text: 'Forschung', useTranslation: false, linkUrl: `https://www.testdaf.de/de/forschung/` } as LinkModel,
        { text: 'g.a.s.t.', useTranslation: false, linkUrl: `https://www.gast.de/` } as LinkModel,
        {
          text: 'g.a.s.t. Akademie',
          useTranslation: false,
          linkUrl: `https://www2.testdaf.de/zielgruppen/fuer-lehrkraefte/fortbildungsangebot/`
        } as LinkModel,
        { text: 'Deutsch-Uni Online', useTranslation: false, linkUrl: `https://www.deutsch-uni.com/de/` } as LinkModel,
        { text: 'onSET', useTranslation: false, linkUrl: `https://www.onset.de/` } as LinkModel,
        { text: 'TestAS', useTranslation: false, linkUrl: `https://www.testas.de/` } as LinkModel
      ],
      serviceLinksTitle: { text: 'COMMON.FOOTER-COMPONENT.OFFERS.TITLE', useTranslation: true } as TextModel,
      serviceLinks: [
        {
          text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.SERVICE_LINKS.FAQ',
          useTranslation: true,
          linkUrl: `https://www.testdaf.de/de/teilnehmende/mein-testdaf/faq/`
        } as LinkModel,
        { text: 'TestAS', useTranslation: false, linkUrl: `https://www.testas.de/` } as LinkModel,
        {
          text: 'Termine und Anmeldung',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/teilnehmende/mein-testdaf/testdaf-termine-und-anmeldung/`
        } as LinkModel,
        {
          text: 'Testzentrum finden',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/teilnehmende/mein-testdaf/testzentrum-finden/`
        } as LinkModel,
        {
          text: 'Informationsmaterialien',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/ueber-testdaf/testdaf-ein-produkt-der-gast/informationsmaterialien/`
        } as LinkModel,
        {
          text: 'Fit für den TestDaF',
          useTranslation: false,
          linkUrl: `https://www2.testdaf.de/teilnehmer/tn-vorbereitung_test.php?id=1`
        } as LinkModel,
        {
          text: 'Testzentrum werden',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/testzentren/testzentrum-werden/testzentrum-werden/`
        } as LinkModel,
        {
          text: 'Forschungsanfragen',
          useTranslation: false,
          linkUrl: `https://www2.testdaf.de/zielgruppen/forschung-und-entwicklung/anfragen/`
        } as LinkModel,
        {
          text: 'Infos in meiner Sprache',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/teilnehmende/warum-testdaf/informationen-in-ihrer-sprache/`
        } as LinkModel,
        {
          text: 'g.a.s.t.-Newsletter Anmeldung',
          useTranslation: false,
          linkUrl: `http://www.gast.d/newsletter-anmeldung)`
        } as LinkModel
      ],
      contactLinksTitle: {
        text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.TITLE',
        useTranslation: true
      } as TextModel,
      contactLinks: [
        {
          text: 'Kontakt',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/ueber-testdaf/kontakt/kontakt-und-besucherinformationen/`
        } as LinkModel,
        { text: 'Impressum', useTranslation: false, linkUrl: `https://www.testdaf.de/de/impressum/` } as LinkModel,
        {
          text: 'Datenschutz',
          useTranslation: false,
          linkUrl: `https://www.testdaf.de/de/datenschutzerklaerung/`
        } as LinkModel,
        { text: 'AGB', useTranslation: false, linkUrl: `https://www.testdaf.de/de/agb/` } as LinkModel],
      gastOfferText: { text: 'Der TestDaF ist ein Angebot von', useTranslation: false } as TextModel,
      facebookUrl: 'https://www.facebook.com/TestDaF/',
      twitterUrl: 'https://twitter.com/testdafinstitut/'
    } as FooterModel;
  }

  private static generateFooter(text: string): FooterModel {
    return {
      gastOfferText: { text: text, useTranslation: false } as TextModel,
    } as FooterModel;
  }

  private static generateDtzFooter(): FooterModel {
    return {
      descriptionTitel: { text: 'Über DTZ', useTranslation: false } as TextModel,
      descriptionText: { text: 'Im Auftrag des Bundesministeriums des Innern übernimmt die Gesellschaft für Akademische Studienvorbereitung und Testentwicklung e.V. (g.a.s.t.) ab dem 01.01.2023 die Administration und Durchführung des Deutsch-Tests für Zuwanderer (DTZ).', useTranslation: false } as TextModel,
      contactLinksTitle: {
        text: 'GAST-PORTAL-NG.FOOTER-COMPONENT.CONTACT_LINKS.TITLE',
        useTranslation: true
      } as TextModel,
      contactLinks: [
        { text: 'Impressum', useTranslation: false, linkUrl: `https://www.gast.de/de/kontakt/impressum` } as LinkModel,
        { text: 'Datenschutz', useTranslation: false, linkUrl: `https://www.gast.de/de/kontakt/datenschutz` } as LinkModel],
      gastOfferText: { text: '   ', useTranslation: false } as TextModel,
    } as FooterModel;
  }

  public generateHeaderStyleModel(showLanguageDropdown: boolean, showLoginDropdown: boolean = true): HeaderStyleModel {
    return {
      languageDropdownVisible: showLanguageDropdown,
      loginDropdownVisible: showLoginDropdown
    } as HeaderStyleModel;
  }

  private isENLocale() {
    return this.translationService.getCurrentLanguageCode().toLowerCase() === 'en';
  }

  private isDELocale() {
    return this.translationService.getCurrentLanguageCode().toLowerCase() === 'de';
  }

}
